import * as React from "react";
function YouTubeColoredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0302",
    d: "M23.522 6.185A3.016 3.016 0 0021.4 4.05c-1.876-.505-9.376-.505-9.376-.505s-7.5 0-9.376.505A3.016 3.016 0 00.526 6.185C.024 8.07.024 12 .024 12s0 3.93.502 5.815a3.017 3.017 0 002.122 2.135c1.876.505 9.376.505 9.376.505s7.5 0 9.376-.505a3.015 3.015 0 002.122-2.135c.502-1.885.502-5.815.502-5.815s0-3.93-.502-5.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M9.57 15.569V8.43L15.841 12 9.57 15.569z"
  }));
}
const ForwardRef = React.forwardRef(YouTubeColoredIcon);
export default ForwardRef;